var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-loading-wrap"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"loading-box",attrs:{"element-loading-text":"正在登录中...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(255, 255, 255, 1)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }